module.exports = __webpack_public_path__ + "static/media/bg-inferior-derecho.6e2cd4ab.svg";